// extracted by mini-css-extract-plugin
module.exports = {"landing":"Landing-module__landing___uTo1d","columnImage":"Landing-module__columnImage___2zXH4"};